//@flow
import { call, put, takeLatest } from "redux-saga/effects";

import { EXTERNAL_USER_SET_REQUESTING } from "./constants";

import { setExternalUser } from "./actions";
import { navigate } from "../navigation/navigatorHelper";

import { fetchApi } from "../api";

const endPoints = {
  getExternalUser: "/v1/users/external/",
};

const getExternalUserApi = data => {
  return fetchApi(endPoints.getExternalUser + data, {}, "get");
};

function* setExternalUserFlow(action) {
  try {
    const { userId } = action.payload;
    navigate("ExternalProfile");
    const user = yield call(getExternalUserApi, userId);

    yield put(setExternalUser(user));
  } catch (error) {
    console.log(error);
  }
}

function* externalProfileWatcher() {
  yield takeLatest(EXTERNAL_USER_SET_REQUESTING, setExternalUserFlow);
}

export default externalProfileWatcher;
